import { useRef } from "react";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { Typography } from "@mui/material";

export default function CategoryCarousel({ items = [] }) {
  const scrollerRef = useRef(null);

  const scrollBy = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    const amount = Math.round(el.clientWidth * 0.9); 
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  return (
    <section className="w-full bg-white">
      <div className="relative max-w-[1400px] mx-auto px-6">

        <div className="relative">

    
          <button
            onClick={() => scrollBy(-1)}
            className="absolute -left-4 top-1/2 -translate-y-1/2 z-20
                       w-12 h-12 flex items-center justify-center
                       bg-white/90 rounded-full shadow-md border hover:bg-white"
          >
            <ChevronLeft fontSize="large" />
          </button>

          <button
            onClick={() => scrollBy(1)}
            className="absolute -right-4 top-1/2 -translate-y-1/2 z-20
                       w-12 h-12 flex items-center justify-center
                       bg-white/90 rounded-full shadow-md border hover:bg-white"
          >
            <ChevronRight fontSize="large" />
          </button>

          {/* Scrollable container */}
          <div
            ref={scrollerRef}
            className="no-scrollbar overflow-x-auto scroll-smooth"
          >
            <div className="flex gap-6 py-6">
              {items.map((it, idx) => (
                <div key={idx} className="min-w-[320px]">
                  <div className="rounded-xl overflow-hidden shadow-sm">
                    <img
                      src={it.img}
                      alt={it.name}
                      className="w-[320px] h-[220px] object-cover"
                      onError={(e) => {
                        e.currentTarget.src = "/assets/images/Sample_Image.png";
                      }}
                    />
                  </div>
                  <Typography
                    className="mt-3 underline text-center text-[18px] font-medium cursor-pointer hover:text-teal-700"
                  >
                    {it.name}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center mt-4">
        <div className="w-[85%] border-t border-gray-300"></div>
      </div>
    </section>
  );
}
